import React, { useState, useEffect } from 'react';
import './CSS/ShopCategory.css';
import Item from '../Components/Item/Item';
import categoriesData from '../Components/Assets/categories.json';
import ProductDetails from '../Components/ProductDetails/ProductDetails'; // Import the new component
import { getApiBaseUrl } from '../config';

const ShopCategory = (props) => {
    const [categoryProducts, setCategoryProducts] = useState([]); 
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [activeSubcategory, setActiveSubcategory] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [sortOrder, setSortOrder] = useState('oldest');
    const [selectedProduct, setSelectedProduct] = useState(null);

    const itemsPerPage = 6;
    const category = categoriesData.categories.find(cat => cat.id === props.category);

    useEffect(() => {
        console.log(`Fetching products for category: ${props.category}...`);

        // Fetch data without token or authorization
        fetch(`${getApiBaseUrl()}/category/${props.category}?page=1&limit=100`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json', // No token needed
            },
            credentials: 'include', // This sends cookies and auth tokens if necessary, without needing a token
        })
        .then(response => response.json())
        .then(data => {
            setCategoryProducts(data.products);
            setTotalPages(Math.ceil(data.products.length / itemsPerPage));
            setActiveSubcategory(data.products[0]?.subcategory || null);
            setFilteredProducts(data.products);
        })
        .catch(error => {
            console.error('Error fetching data for category:', error);
        });

    }, [props.category]); 

    useEffect(() => {
        console.log(`Filtering products for subcategory: ${activeSubcategory}`);
        if (activeSubcategory) {
            const filtered = categoryProducts.filter(product => product.subcategory === activeSubcategory);
            setFilteredProducts(filtered); 
            setCurrentPage(1); 
            setTotalPages(Math.ceil(filtered.length / itemsPerPage)); 
        } else {
            setFilteredProducts(categoryProducts); 
            setTotalPages(Math.ceil(categoryProducts.length / itemsPerPage)); 
        }
    }, [activeSubcategory, categoryProducts]); 

    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (sortOrder === 'oldest') return new Date(a.date) - new Date(b.date);
        if (sortOrder === 'most_expensive') return b.new_price - a.new_price;
        if (sortOrder === 'alphabetical') return a.name.localeCompare(b.name);
        return 0;
    });

    const indexOfLastProduct = currentPage * itemsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
    const currentProducts = sortedProducts.slice(indexOfFirstProduct, indexOfLastProduct);

    const handleSubcategoryClick = (subcategory) => {
        console.log(`Subcategory clicked: ${subcategory}`);
        setActiveSubcategory(subcategory); 
        setSelectedProduct(null); 
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleItemClick = (productId) => {
        console.log(`Item ID: ${productId}`);

        const product = categoryProducts.find(item => item._id === productId);
        console.log("Selected product:", product); // Debug the selected product
        setSelectedProduct(product); // Set the selected product
    };
    
    const handleCloseProductDetails = () => {
        setSelectedProduct(null); // Close the product details view
    };

    return (
        <div className="shop-category">
            <div className="shopcategory-header">
                <h1>{category ? category.name : 'Shop'}</h1>
            </div>

            {category && category.subcategories && (
                <div className="shopcategory-subcategories">
                    {category.subcategories.map(subcategory => (
                        <span
                            key={subcategory}
                            className={`subcategory-text ${activeSubcategory === subcategory ? 'active' : ''}`}
                            onClick={() => handleSubcategoryClick(subcategory)}
                        >
                            {subcategory.replace('-', ' ')}
                        </span>
                    ))}
                </div>
            )}

            <div className="shopcategory-products">
                {selectedProduct ? (
                    <ProductDetails 
                        product={selectedProduct} 
                        onClose={handleCloseProductDetails} // Pass the close function to ProductDetails
                    />
                ) : (
                    currentProducts.length > 0 ? (
                        currentProducts.map(item => (
                            <Item
                                key={item._id}
                                id={item._id}
                                name={item.name}
                                image={item.images[0]} // Display only the first image by default
                                new_price={item.new_price}
                                old_price={item.old_price}
                                onClick={() => handleItemClick(item._id)} // Pass onClick handler here
                            />
                        ))
                    ) : (
                        <p>No products found for this subcategory.</p>
                    )
                )}
            </div>

            <div className="pagination">
                <button onClick={handlePrev} disabled={currentPage === 1}>
                    &#10094; Prev
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button onClick={handleNext} disabled={currentPage === totalPages}>
                    Next &#10095;
                </button>
            </div>
        </div>
    );
};

export default ShopCategory;
